<script setup>
import AppIcon from './AppIcon.vue'
defineProps({ title: String, description: String, icon: { type: String, default: 'policies' }, action: String })
defineEmits(['action'])
</script>
<template><div class="empty-state"><div class="empty-icon"><AppIcon :name="icon" tone="primary" :size="42"/></div><h2>{{ title }}</h2><p>{{ description }}</p><button v-if="action" class="button-primary" @click="$emit('action')"><AppIcon name="add" tone="white" :size="18"/>{{ action }}</button></div></template>
